import { ButtonHTMLAttributes, forwardRef } from 'react';

import { Button, Input, InputGroup } from 'reactstrap';

import { FontAwesomeIcon, IconButton, If } from '@hsp/react-component-library';

import { DatePickerProps } from 'types/components/date-picker/date-picker.props';

const DatePickerInput = forwardRef<Input, ButtonHTMLAttributes<HTMLButtonElement> & DatePickerProps>(
  ({ disabled, isClearable, placeholder, onClick, value, onClear }, ref) => {
    return (
      <InputGroup>
        <Input
          defaultValue={value}
          disabled={disabled}
          key={value?.toString()}
          placeholder={placeholder}
          readOnly
          ref={ref}
          type="search"
        />
        <If condition={isClearable ?? true}>
          <IconButton
            className="clear-button"
            color="gray-400"
            disabled={disabled}
            icon={['fas', 'times']}
            onClick={onClear}
            outline
          />
        </If>
        <Button
          className="calendar-button"
          color="gray-400"
          disabled={disabled}
          onClick={onClick}
          outline
          type="button">
          <FontAwesomeIcon icon={['fas', 'calendar']} />
        </Button>
      </InputGroup>
    );
  }
);

DatePickerInput.displayName = 'DatePickerInput';

export default DatePickerInput;
